<template>
	<div class="app-item">
		<div @click='click_handle'>
			<van-image :src='item.icon'></van-image>
			<div class="text">{{item.name}}</div>
		</div>
	</div>
</template>
<script>
	export default {
		props: ["item"],
		data() {
			return {
				user: this.$config.userinfo,
			};
		},
		methods: {
			click_handle() {
				if (this.user.login_status < 2) {
					this.$login();
				} else {
					window.location.href = this.item.host + this.item.url;
				}
			},
		},
	};
</script>